import React, { Fragment, use, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import ModelConfigurationTabs from './ModelConfigurationTabs';
import { useSelector, useDispatch } from 'react-redux';
import { getModelManager } from '../../selectors/index';
import s from './ModelConfigurationContentTemplate.module.scss';
import { describeModelThunk } from '../../actions/model';


const ModelConfigurationContentTemplate = ({ children, selectedPage = '', userProfileWidgets, intl }) => {
  let { ModelCategoryId, ModelId } = useParams();
  let widgetCode = 'MODEL_CONFIGURE';
  const dispatch = useDispatch();
  
  const modelManager = useSelector(state => getModelManager(state));
  useEffect(() => {
    if (ModelId && ModelCategoryId && widgetCode) {
      // Fetch model details if not already available
      if (!modelManager.selectedModel || modelManager.selectedModel.ModelId != ModelId) {
        dispatch(describeModelThunk(ModelId, null, widgetCode, ModelCategoryId, true, true));
      }
    }
  }, [ModelId, ModelCategoryId, widgetCode]);
  

  const modelName = (modelManager.selectedModel ? modelManager.selectedModel.Name : '') || '';
  const titleHeading = intl.formatMessage({ id: 'model.modelConfiguration', defaultMessage: 'Model Configuration' }) + (modelName ? ` - ${modelName}` : '');
  return (
    <Fragment>
      <div className={s.fullWidth}>
        <div className={s.fullWidthWrapper}>
          <h1 className={s.tabHeader}>{titleHeading}</h1>
          {<ModelConfigurationTabs selectedPage={selectedPage} userProfileWidgets={userProfileWidgets} />}
        </div>
      </div>

      <div className={s.pageContent}>{children}</div>
    </Fragment>
  )
};

ModelConfigurationContentTemplate.propTypes = {
  backLink: PropTypes.string,
  children: PropTypes.node.isRequired,
  selectedPage: PropTypes.string,
  userProfileWidgets: PropTypes.object
};

export default ModelConfigurationContentTemplate;
